import { useEffect, useCallback } from 'react';

function useBoardFocus(boardsRef, boards, loading) {
  const scrollToInProgressBoard = useCallback(() => {
    if (!boardsRef.current || loading || !boards.length) return;

    // Find the first "in_progress" board
    const inProgressIndex = boards.findIndex(board => board.status === 'in_progress');
    
    if (inProgressIndex !== -1) {
      // Calculate scroll position
      const container = boardsRef.current;
      const boardWidth = 300; // Board width + gap
      const gap = 16; // Gap between boards
      const scrollX = inProgressIndex * (boardWidth + gap);
      
      // Smooth scroll to the in-progress board
      container.scrollTo({
        left: scrollX,
        behavior: 'smooth',
      });

      console.log(`🎯 Auto-focused on "In Progress" board: ${boards[inProgressIndex].name}`);
    } else {
      // If no in-progress board, scroll to the beginning
      boardsRef.current.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
      
      console.log('📍 No "In Progress" boards found, scrolled to start');
    }
  }, [boardsRef, boards, loading]);

  // Auto-focus when boards load or change
  useEffect(() => {
    if (!loading && boards.length > 0) {
      // Small delay to ensure DOM is ready
      const timeoutId = setTimeout(scrollToInProgressBoard, 300);
      return () => clearTimeout(timeoutId);
    }
  }, [boards, loading, scrollToInProgressBoard]);

  // Return the scroll function for manual use
  return {
    scrollToInProgressBoard,
    focusBoard: useCallback((boardId) => {
      if (!boardsRef.current || !boards.length) return;
      
      const boardIndex = boards.findIndex(board => board.id === boardId);
      if (boardIndex !== -1) {
        const container = boardsRef.current;
        const boardWidth = 300;
        const gap = 16;
        const scrollX = boardIndex * (boardWidth + gap);
        
        container.scrollTo({
          left: scrollX,
          behavior: 'smooth',
        });
      }
    }, [boardsRef, boards])
  };
}

export default useBoardFocus;